import wrapOnClick from 'onyx-common/wrapOnClick'
import MuiButton from '@material-ui/core/Button'

export default wrapOnClick(MuiButton)
